import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const SplitpaneStyle = (theme: Theme) => createStyles({
  drawer : {
    zIndex:1,
    height: '35px',
    minHeight: '35px',
    width: '100%',
    backgroundColor: styleColors.white,
    borderRadius: '12px 12px 0px 0px',
    boxShadow: `0px 0px 10px ${styleColors.chromePurpleShadow}`,
    border: `0.5px solid ${styleColors.greyMedium1}`,
    boxSizing: 'border-box',
    borderBottom: '0px',
    position:'relative',
    userSelect:'none',
    WebkitUserSelect: 'none',
    transition: 'background-color 0.4s',
  },
  
  marker : {
    width:'60px',
    height: '3px',
    backgroundColor: styleColors.greyLight3,
    position: 'absolute',
    top: '7px',
    borderRadius: '3px',
    left: 'calc(50% - 30px)',
  },
  splitpane : {
    position:'fixed', 
    bottom:0, 
    minWidth:'100%'
  }
});




// WEBPACK FOOTER //
// ./src/components/calendar2/splitpane/Splitpane.style.ts